import Swiper, { Navigation, Pagination, EffectFade } from "swiper";

export default () => {
	// https://apps.shopify.com/my-wishlist-share-remind
	const KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYWNmOWZmNzczNDQwYmE5MTgxMjBjOGM1OGM0OTViYTZmZGQ4OWNkMjMzNGIwMmVlNzZlMDExMjBkZmQ3NWUzZTk0ZGIzMDlmNWUxNDc4YWMiLCJpYXQiOjE2ODk2NzMwODksIm5iZiI6MTY4OTY3MzA4OSwiZXhwIjozNTgzMTI5MDg5LCJzdWIiOiI3MzkwIiwic2NvcGVzIjpbXX0.YGIExRzZiNz9fS97hNizn_Jc39vubuB4btn5uDqI_jldycrw5ic-Rm_YeI1HSBolFMs1v5I2KH-9-roGeyBy8eHmVRtMjSiuGg_vaivis6TBt7N53umh6hT7sigtCIo0vSBuKbdWzEpndcOAhUC1DBH6uj9sQUhjAAl2boMx0BLoJ8l9a6Miiu-tnXDNy3En97UPLi1j7T3kJjvWvX815cnrno-Dx97ayWBWzCjx628nYJHOwZU4-F3Z5W_n9pHsOHb5YhIK8jE4oCNy-tUiRRjxIOgEZV2rpPVKYPP0H1KL4ecY8Z-ThvYSG-p6VBAB9sPVXgNocLZqHQUb97Qk7mPQOd_gC246xjTXTs-f71XoEV4n3lFkZtdCBSYofDiYScuGJU93eiqGnC4EGivA5kCHrYELJkrODuS-QJaq1fSHsmWTcQ_nJ7kYQM7PvZ24aBjCky2r8oATeYPfpsDTVazbO1LCZzankDcCTTXPL6dYZpZ80wb1GrEDAhqkt67Lz6qu1HOKe8YvdAibllf7_jA1x93z4xad2VcertMyPnV3-a74nGQ708M8fklOJj2cCCg6g2toD1dpLhCX6pPisGdsYtah4Nmp_KbDJRn7IIVS4t4DVCCKp_8VIaA5iYHH1VAE3vjJK26AiPddKJNsmKChLS64jdjCpds0uvXTwGg';

	let cid = window.customer;
	const wishlistWrapper = document.querySelector('.js-wishlist-holder');
	const counter = document.querySelector('.js-wishlist-counter');

	checkIfCustomer();

	const button = document.querySelector('.js-wishlist-toggle');
	if (button) {
		button.addEventListener('click', (e) => {
			e.preventDefault();

			let pid = button.dataset.pid;
			let vid = button.dataset.vid;

			if(pid && vid) {
				if (button.classList.contains('is-active')) {
					button.classList.remove('is-active');
					removeAllVariants(pid);
				} else {
					// button.classList.add('is-active')
					// add(pid, vid);
					const sizeSelector = document.querySelector('.wl-size__btn.js-open-popup');
					if (sizeSelector) {
						sizeSelector.click();
					}
					/*
					const popup = document.querySelector('.popup[data-popup="wl-add"]');
					if (popup) {
						popup.classList.add('popup--visible');
					} */
				}
			}
		});
	}


	document.addEventListener('click', (e) => {
		if(e.target.classList.contains('js-remove-from-wishlist')) {
			e.preventDefault();
			let pid = e.target.dataset.pid;
			let vid = e.target.dataset.vid;
			if (e.target.dataset.handled === 'true') return;

			if(pid && vid) {
				e.target.dataset.handled = 'true';
				let card = e.target.closest('.js-card');
				if (card) {
					card.remove();
				}
				remove(pid, vid);

				let counter = document.querySelector('.js-wishlist-counter');
				let new_count = parseInt(counter.innerHTML) - 1;
				if (new_count <= 0) {
					new_count = "";
				}
				counter.innerHTML = new_count;
			}
		}

		if(e.target.classList.contains('js-move-to-wishlist')) {
			// console.log('move to wishlist btn click');
			e.preventDefault();
			let pid = e.target.dataset.pid;
			let vid = e.target.dataset.vid;

			if(pid && vid) {
				add(pid, vid, true);
			}
		}

		if(e.target.closest('.js-add-to-wl')) {
			const btn = e.target.closest('.js-add-to-wl');
			e.preventDefault();

			let pid = btn.dataset.pid;
			let vid = btn.dataset.id;

			if(pid && vid) {
				add(pid, vid, true);
			}
		}

	});

	function updateWishlist() {
		const uuid = getUuid();

		if	(!uuid && !window.customer) {
			return;
		}

		get().then(data => {
			let items = data.data;

			if (items) {
				items = items.filter((item, index, self) =>
					index === self.findIndex((t) => (
						t.variant_id === item.variant_id
					))
				);

				renderWishlist(items);
			}
		});
	}

	function add(pid, vid, openwishlist = false) {
		let url;

		if(window.customer) {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/add_product"
			);
		} else {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/add_product/guest"
			);
		}


		let headers = {
			"Authorization": `Bearer ${KEY}`,
			"Content-Type": "application/json",
			"Accept": "application/json",
		};

		let body = {
			"product_id": pid,
			"variant_id": vid,
		}

		if (window.customer) {
			body.customer_id = window.customer;
		} else {
			let uuid = getUuid();
			if (uuid) {
				body.uuid = uuid;
			}
		}

		fetch(url, {
			method: "POST",
			headers,
			body: JSON.stringify(body),
		}).then((response) => response.json())
		.then((data) => {
			data;

			let uuid = getUuid();
			if (!uuid) {
				// console.log(`no uuid found`);

				try {
					if(typeof data.data.uuid != 'undefined') {
						const new_uuid = data.data.uuid;
						// console.log({new_uuid});
						setUuid(new_uuid);
					}
				} catch (error) {
					console.error(error);
				}
			}

			updateWishlist();
			if (openwishlist) {
				openWishlist();
			}
		})
	}



	function remove(pid, vid, silent = false) {
		let url;

		if(window.customer) {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/delete_product"
			);
		} else {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/delete_product/guest"
			);
		}

		let headers = {
			"Authorization": `Bearer ${KEY}`,
			"Content-Type": "application/json",
			"Accept": "application/json",
		};

		let body = {
			"product_id": pid,
			"variant_id": vid,
		}

		if (window.customer) {
			body.customer_id = window.customer;
		} else {
			let uuid = getUuid();
			if (uuid) {
				body.uuid = uuid;
			}
		}

		fetch(url, {
			method: "POST",
			headers,
			body: JSON.stringify(body),
		}).then((response) => response.json())
		.then((data) => {
			data;

			if (!silent) {
				updateWishlist();
			}
		})
	}


	function get() {
		let url;
		let params;

		if(window.customer) {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/products"
			);
		} else {
			url = new URL(
				"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/products/guest"
			);
		}


		if(window.customer) {
			params = {
				"customer_id": window.customer,
			};
		} else {
			const uuid = getUuid();
			if (!uuid) return;
			params = {
				"uuid": uuid,
			};
		}
		// guest




		Object.keys(params)
			.forEach(key => url.searchParams.append(key, params[key]));

		let headers = {
			"Authorization": `Bearer ${KEY}`,
			"Content-Type": "application/json",
			"Accept": "application/json",
		};

		return fetch(url, {
			method: "GET",
			headers,
		})
		.then(response => response.json())
		.then(data => data);
	}


	function getGuest() {
		const url = new URL(
			"https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/products/guest"
		);

		const uuid = getUuid();
		if (!uuid) return;

		let params = {
			"uuid": uuid,
		};

		Object.keys(params)
			.forEach(key => url.searchParams.append(key, params[key]));

		let headers = {
			"Authorization": `Bearer ${KEY}`,
			"Content-Type": "application/json",
			"Accept": "application/json",
		};

		return fetch(url, {
			method: "GET",
			headers,
		})
		.then(response => response.json())
		.then(data => data);
	}





	function getItemHtml(handle, variant) {
		if (!handle) {
			return Promise.reject('No handle provided');
		}

		const base = window.location.origin;
		const params = `/products/${handle}/?view=card`;
		let variantString = '';
		if(variant) {
			variantString = `&variant=${variant}`;

		}
		const url = `${base}${params}${variantString}`;

		return fetch(url)
			.then(function (response) {
				return response.text();
			})
			.catch(function (err) {
				console.warn('Something went wrong.', err);
			});
	}


	function renderWishlist(items) {
		counter.innerHTML = items.length;
		setButtonsState(items);
		wishlistWrapper.innerHTML = '';

		Promise.all(items.map((item) => getItemHtml(item.handle, item.variant_id)))
			.then((elements) => {
			elements.forEach((element) => {

				const htmlEl = document.createElement('div');
				htmlEl.innerHTML = element;
				const removeButton = htmlEl.querySelector('.js-remove-from-wishlist');
				//removeButton
				wishlistWrapper.appendChild(htmlEl);

				const sliderEl = htmlEl.querySelector('.js-card-img-slider');

				const slider = new Swiper(sliderEl, {
					modules: [ Navigation, Pagination, EffectFade ],
					speed: 200,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
					},
				});

				htmlEl.addEventListener('mouseenter', () => {
					slider.slideNext();
				});

				htmlEl.addEventListener('mouseleave', () => {
					slider.slideTo(0);
				});
			});
		})
			.catch((error) => {
			console.error('Error fetching items:', error);
		});
  }

	function setUuid(id) {
		localStorage.setItem('wishlist-uuid', id);
	}

	function getUuid() {
		let id = localStorage.getItem('wishlist-uuid');
		if(id) {
			return id;
		} else {
			return false;
		}
	}

	function clearUuid() {
		// console.log('clearUuid()');
		localStorage.removeItem('wishlist-uuid');
	}

	function isGuest() {
		let customer = window.customer;
		if (customer) {
			return false;
		} else {
			return true;
		}
	}

	function setButtonsState(items) {
		let buttons = document.querySelectorAll('.js-wishlist-toggle');

		buttons.forEach((button) => {
			let pid = button.dataset.pid;
			let vid = button.dataset.vid;

			let isAdded = items.find(item => item.product_id == pid && item.variant_id == vid);

			if (isAdded) {
				button.classList.add('is-active');
			} else {
				button.classList.remove('is-active');
			}
		});
	}

	function openWishlist() {
		const btn = document.querySelector('.js-open-popup[data-popup="wishlist"]');
		const wlSelectorPopup = document.querySelector('.popup[data-popup="wl-add"]');
		if (btn) {
			btn.click();

			if (wlSelectorPopup) {
				wlSelectorPopup.classList.remove('popup--visible');
			}
		}
	}

	function checkIfCustomer() {
		let uuid = getUuid();

		if (!isGuest() && uuid) {
			moveFomGuestToCustomer();
		} else {
			updateWishlist();
		}
	}


	function moveFomGuestToCustomer() {
		getGuest().then(data => {
			let items = data.data;

			items.forEach((item) => {
				let pid = item.product_id;
				let vid = item.variant_id;

				add(pid, vid);
			});
		});

		clearUuid();

		setTimeout(() => {
			updateWishlist();
		}	, 1000);
	}


	function removeAllVariants(pid) {
		const isSilent = false;

		const uuid = getUuid();
		if (!uuid) return;

		get().then(data => {
			let items = data.data;

			items.forEach((item) => {
				let id = item.product_id+'';
				if	(pid == id) {
					let vid = item.variant_id + '';

					remove(pid, vid, isSilent);
				}
			});
		});

	}

}
